import React from 'react';
import {Box, Typography} from '@mui/material';
import { Timeline, TimelineItem, TimelineSeparator, TimelineDot, TimelineConnector, TimelineContent, TimelineOppositeContent } from '@mui/lab';
import WorkIcon from '@mui/icons-material/Work';
import experienceData from '../Data/ExperienceData';

const Experience = () => (
    <React.Fragment>
    <Timeline position="alternate">
        {experienceData.map((experience, index) => (
            <TimelineItem key={index}>
                <TimelineOppositeContent sx={{ m: 'auto 0' }} align="right" variant="body2" color="text.secondary">
                    {experience.date}
                </TimelineOppositeContent>
                <TimelineSeparator>
                    <TimelineDot color="primary">
                        <WorkIcon />
                    </TimelineDot>
                    {index < experienceData.length - 1 && <TimelineConnector />}
                </TimelineSeparator>
                <TimelineContent sx={{ py: 2, px: 2 }}>
                    <Typography variant="h6" component="span" fontWeight="bold">
                        {experience.title}
                    </Typography>
                    <Typography variant="subtitle2" color="text.secondary">
                        {experience.link == null ? experience.company : <a href={experience.link} target='_blank' rel='noreferrer' style={{color: experience.color}}>{experience.company}</a>}
                    </Typography>
                    <Typography variant="body2">{experience.description}</Typography>
                </TimelineContent>
            </TimelineItem>
        ))}
    </Timeline>
        <Box>
            <Typography variant="h6" fontWeight="bold">
                Additional Work
            </Typography>
            <Box>
                <Typography variant="body2" display="block">
                    Engaged in an 8-month freelance project with <a href='https://akvelon.com/' target='_blank' rel='noreferrer' style={{fontWeight: 'bold', color: 'orange'}}>Akvelon Inc.</a>, outsourced to a Fortune 500 company, focusing on enhancing cloud performance, security, and reliability. Developed a .NET solution for live metrics and diagnostic tools to streamline issue triage across cloud resources, ensuring consistent performance and security standards. Responsibilities included managing cloud resources, adjusting deployment pipelines via YAML configurations, and delivering impactful features within a dynamic and high-stakes environment.
                </Typography>
                <Typography variant="body2" display="block">
                    Developed automation pipelines for RECIST longitudinal reads, lesion propagation prediction, and sequence registration using Aquarius AI workflows. Designed robust .NET controllers and background services for ROI tracking, DICOM sequence validation, and phase‑based trial automation. Collaborated with radiologists and clinical data managers to ensure compliance with study protocols and streamline data integrity across multi‑timepoint reads as part of Clario LLC.
                </Typography>
                <Typography variant="body2" display="block">
                    Other freelance projects included creating console, WPF, Web applications for various clients. You can check out some of them on my Github page which you can access by clicking on the link at the top.
                </Typography>
            </Box>
        </Box>
    </React.Fragment>
);

export default Experience;